import * as React from 'react';
import classnames from 'classnames';
import { Loader } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import SelectedChoices from '../SelectedChoices/SelectedChoicesContainer.js';

const AppointmentCustomerForm = ({ className , loading , loggedIn , Form , title , layout , initialFormState , onChange , onSubmit , submitting =false , disableSubmit =false , beforeSubmitSlot =null , formAlert =null ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('appointment-customer-form', className)
    }, /*#__PURE__*/ React.createElement(SelectedChoices, null), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "appointment-customer-form__title"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "appointment-customer-form__container",
        "aria-live": "polite"
    }, loading ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-customer-form__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)) : Form && /*#__PURE__*/ React.createElement(Form, {
        className: "appointment-customer-form__content",
        name: "bookAppointment",
        initialFormState: initialFormState,
        layout: layout,
        loggedIn: loggedIn,
        submitting: submitting,
        disableSubmit: disableSubmit,
        beforeSubmitSlot: beforeSubmitSlot,
        formAlert: formAlert,
        onChange: onChange,
        onSubmit: onSubmit
    })))
;
var AppointmentCustomerForm$1 = AppointmentCustomerForm;

export { AppointmentCustomerForm, AppointmentCustomerForm$1 as default };
//# sourceMappingURL=AppointmentCustomerForm.js.map
